export default "__VITE_ASSET__3dea0afb__"